import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import LineString from '../../geom/LineString';
import Geometry from '../../geom/Geometry';
import hasInterface from '../../../../../hasInterface';
import Collection from '../../../../../java/util/Collection';
import Point from '../../geom/Point';
import Polygon from '../../geom/Polygon';
import GeometryCollection from '../../geom/GeometryCollection';
import Dimension from '../../geom/Dimension';
import ArrayList from '../../../../../java/util/ArrayList';
import GeometryFilter from '../../geom/GeometryFilter';
import Assert from '../../util/Assert';
var InputExtracter = /*#__PURE__*/function () {
  function InputExtracter() {
    _classCallCheck(this, InputExtracter);
    InputExtracter.constructor_.apply(this, arguments);
  }
  _createClass(InputExtracter, [{
    key: "getFactory",
    value: function getFactory() {
      return this._geomFactory;
    }
  }, {
    key: "recordDimension",
    value: function recordDimension(dim) {
      if (dim > this._dimension) this._dimension = dim;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return this._dimension;
    }
  }, {
    key: "filter",
    value: function filter(geom) {
      this.recordDimension(geom.getDimension());
      if (geom instanceof GeometryCollection) return null;
      if (geom.isEmpty()) return null;
      if (geom instanceof Polygon) {
        this._polygons.add(geom);
        return null;
      } else if (geom instanceof LineString) {
        this._lines.add(geom);
        return null;
      } else if (geom instanceof Point) {
        this._points.add(geom);
        return null;
      }
      Assert.shouldNeverReachHere('Unhandled geometry type: ' + geom.getGeometryType());
    }
  }, {
    key: "getExtract",
    value: function getExtract(dim) {
      switch (dim) {
        case 0:
          return this._points;
        case 1:
          return this._lines;
        case 2:
          return this._polygons;
      }
      Assert.shouldNeverReachHere('Invalid dimension: ' + dim);
      return null;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._polygons.isEmpty() && this._lines.isEmpty() && this._points.isEmpty();
    }
  }, {
    key: "add",
    value: function add() {
      if (hasInterface(arguments[0], Collection)) {
        var geoms = arguments[0];
        var _iterator = _createForOfIteratorHelper(geoms),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var geom = _step.value;
            this.add(geom);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (arguments[0] instanceof Geometry) {
        var _geom = arguments[0];
        if (this._geomFactory === null) this._geomFactory = _geom.getFactory();
        _geom.apply(this);
      }
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryFilter];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geomFactory = null;
      this._polygons = new ArrayList();
      this._lines = new ArrayList();
      this._points = new ArrayList();
      this._dimension = Dimension.FALSE;
    }
  }, {
    key: "extract",
    value: function extract() {
      if (hasInterface(arguments[0], Collection)) {
        var geoms = arguments[0];
        var extracter = new InputExtracter();
        extracter.add(geoms);
        return extracter;
      } else if (arguments[0] instanceof Geometry) {
        var geom = arguments[0];
        var _extracter = new InputExtracter();
        _extracter.add(geom);
        return _extracter;
      }
    }
  }]);
  return InputExtracter;
}();
export { InputExtracter as default };